export default __webpack_public_path__ + "static/media/02.60c7234a.svg";